import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MeasurementSelectionService {
    private readonly selectedMeasurementIdSubject = new BehaviorSubject<string | null>(null);
    private readonly loadingSubject = new BehaviorSubject(false);

    public readonly selectedMeasurementId$: Observable<string | null> =
        this.selectedMeasurementIdSubject.asObservable();

    public readonly loading$: Observable<boolean> = this.loadingSubject.asObservable();

    public selectMeasurement(measurementId: string): void {
        this.selectedMeasurementIdSubject.next(measurementId);
    }

    public setLoading(loading: boolean): void {
        this.loadingSubject.next(loading);
    }

    public clearSelection(): void {
        this.selectedMeasurementIdSubject.next(null);
    }

    public getCurrentSelection(): string | null {
        return this.selectedMeasurementIdSubject.value;
    }
}
